import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Flex, Button, Modal, Text } from '@mantine/core'
import { getDetailPackageShipment, deletePackageShipmentStatus } from '../../../../services/package'
import { IconPlus } from '@tabler/icons-react'
import LoadingData from '../../../ui/LoadingData'
import NoData from '../../../ui/NoData'
import TrackingStatusTable from './LayoutHelper/TrackingStatusTable'
import FormAdjustTracking from './Form/FormAdjustTracking'
import { modalDeleteDataUsePayload } from '../../../ui/Prompt/modalDeleteDataUsePayload'

const labelTable = [
  {
    label: 'Date',
    width: 'auto'
  },
  {
    label: 'Tracking Status',
    width: 'auto'
  },
  {
    label: 'Comment',
    width: 'auto'
  },
  {
    label: 'Created By',
    width: 'auto'
  },
  {
    label: 'Updated By',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const PackageShipmentStatus = () => {
  const params = useParams()
  const packageId = params.package_id
  const [loadingHistory, setLoadingHistory] = useState(true)
  const [historyStatusList, setHistoryStatusList] = useState([])
  const [openFormTracking, setOpenFormTracking] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetTrackingStatus = async () => {
    setLoadingHistory(true)
    const params = {
      include: 'creator,updater,status,packaging',
      timestamp: `${new Date().getTime()}`
    }
    try {
      const response = await getDetailPackageShipment(packageId, params)
      if (response.success) {
        const dataHistory = response.data.attributes.history_status
        const pickIncludedCreator = response.included.creator || []
        const pickIncludedUpdater = response.included.updater || []
        const pickIncludedStatus = response.included.status || []

        const getDataUser = (userId, included) => {
          let data = null
          const findUser = included[userId]
          if (findUser) {
            data = {
              id: findUser.attributes.id,
              name: findUser.attributes.name
            }
          }
          return data
        }

        const getDataStatus = (statusId, included) => {
          let statusName = ''
          const findStatus = included[statusId]
          if (findStatus) {
            statusName = findStatus.attributes.name
          }
          return statusName
        }

        const sortByDate = (dataHistory) =>  {
          const data = dataHistory.sort((oldData, newData) => {
            return new Date(oldData.date) - new Date(newData.date)
          })
          return data
        }

        const remapData = dataHistory.map((val) => {
          return {
            ...val,
            creator: val.created_by ? getDataUser(val.created_by, pickIncludedCreator) : null,
            updater: val.updated_by ? getDataUser(val.updated_by, pickIncludedUpdater) : null,
            status_name: val.status_id ? getDataStatus(val.status_id, pickIncludedStatus) : null
          }
        })


        setHistoryStatusList(sortByDate(remapData))
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingHistory(false)
    }
  }

  useEffect(() => {
    handleGetTrackingStatus()
    // eslint-disable-next-line
  }, [])

  const actions = {
    edit: (val) => {
      setOpenFormTracking(true)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteDataUsePayload('Tracking Status', packageId, val.id, val.status_name, deletePackageShipmentStatus, handleGetTrackingStatus)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseFormTracking = () => {
    setOpenFormTracking(false)
    setDetailData(null)
  }

  return (
    <Box>
      <Box my={10}>
        <Flex justify='flex-end' align='center' my={20}>
          <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={() => setOpenFormTracking(true)}>Add Tracking Status</Button>
        </Flex>
      </Box>
      <Box my={30}> 
        {loadingHistory ? <LoadingData /> : historyStatusList.length > 0 ? <TrackingStatusTable label={labelTable} data={historyStatusList} actionMethod={handleAction} /> : <NoData />}
      </Box>
      <Modal opened={openFormTracking} onClose={onCloseFormTracking} centered closeOnClickOutside={false} size='md' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Tracking Status</Text>} withCloseButton={false}>
        <FormAdjustTracking dataTracking={detailData} onCloseForm={onCloseFormTracking} reloadList={handleGetTrackingStatus} />
      </Modal>
    </Box>
  )
}

export default PackageShipmentStatus